import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

const Dropdown = forwardRef(({
  id = 'dropdown',
  value = '',
  options,
  onChange,
  label,
  valueType = 'string',
}, ref) => {
  const handleChange = (e) => {
    const newValue = e.target.value;
    onChange(valueType === 'number' ? Number(newValue) : newValue);
  };

  return (
    <div>
      <label htmlFor={id}>{label}</label>
      <select
        id={id}
        value={valueType === 'number' ? String(value) : value}
        onChange={handleChange}
        ref={ref} // ✅ Forwarding ref properly
      >
        <option value="" disabled>Select an option</option>
        {options.map((option) => (
          <option key={option.id} value={String(option.id)}>
            {option.name}
          </option>
        ))}
      </select>
    </div>
  );
});

// ✅ Add display name to avoid warning
Dropdown.displayName = 'Dropdown';

// ✅ Define propTypes AFTER forwardRef
Dropdown.propTypes = {
  id: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  options: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  })).isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  valueType: PropTypes.oneOf(['string', 'number']),
};

// ✅ Export the component
export default Dropdown;
